(function() {
    var ASSET = window.ASSET_BASE || '';

    // ---- Load config from section JSON or use defaults ----
    var CONFIG = null;
    try {
        var cfgEl = document.getElementById('builderConfigData');
        if (cfgEl) CONFIG = JSON.parse(cfgEl.textContent);
    } catch(e) {}

    function cleanArray(arr) {
        if (!arr) return [];
        return arr.filter(function(x) { return x !== null && x !== undefined; });
    }

    var STONES = cleanArray(CONFIG && CONFIG.stones) || [];
    if (STONES.length === 0) {
        try {
            var el = document.getElementById('builderStonesData');
            if (el) STONES = JSON.parse(el.textContent);
        } catch(e) {}
    }
    if (STONES.length === 0) {
        STONES = [
            { id: 'amethyst', name: 'אמטיסט', energy: 'שקט פנימי', colors: ['purple'], energyTags: ['calm','intuition'], gradient: ['#c89bdf','#9B59B6','#7D3C98'], priceAdd: 0, image: ASSET + 'beads-amethyst.jpg' },
            { id: 'rose-quartz', name: 'רוז קוורץ', energy: 'אהבה ורכות', colors: ['pink'], energyTags: ['love'], gradient: ['#f5d5d8','#E8B4B8','#d4969b'], priceAdd: 0, image: ASSET + 'beads-rose-quartz.jpg' },
            { id: 'tiger-eye', name: 'טייגר אי', energy: 'אומץ וביטחון', colors: ['brown'], energyTags: ['courage','focus'], gradient: ['#daa520','#B8860B','#8B6914'], priceAdd: 30, image: ASSET + 'beads-tiger-eye.jpg' },
            { id: 'turquoise', name: 'טורקיז', energy: 'ריפוי והגנה', colors: ['blue','green'], energyTags: ['healing','protection'], gradient: ['#7fffd4','#40E0D0','#2ab5a5'], priceAdd: 50, image: ASSET + 'beads-turquoise.jpg' },
            { id: 'onyx', name: 'אוניקס שחור', energy: 'כוח ועוצמה', colors: ['black'], energyTags: ['protection','courage'], gradient: ['#555','#2C2825','#1a1a1a'], priceAdd: 0, image: ASSET + 'beads-onyx.jpg' },
            { id: 'aventurine', name: 'אוונטורין', energy: 'צמיחה ושפע', colors: ['green'], energyTags: ['abundance','healing'], gradient: ['#8fbc8f','#6B8E6B','#4a6b4a'], priceAdd: 0, image: ASSET + 'beads-aventurine.jpg' },
            { id: 'lapis', name: 'לאפיס לזולי', energy: 'חוכמה ואמת', colors: ['blue'], energyTags: ['focus','intuition'], gradient: ['#3b6ba5','#1E3A5F','#0f2540'], priceAdd: 70, image: ASSET + 'beads-lapis.jpg' },
            { id: 'moonstone', name: 'מונסטון', energy: 'אינטואיציה', colors: ['white'], energyTags: ['intuition','calm'], gradient: ['#fff','#D4CFC9','#b8b0a6'], priceAdd: 60, image: ASSET + 'beads-moonstone.jpg' },
            { id: 'amazonite', name: 'אמזוניט', energy: 'שקט וריפוי', colors: ['green','blue'], energyTags: ['calm','healing'], gradient: ['#98d8c8','#5fb5a0','#3d9e87'], priceAdd: 20, shadeNote: true, image: ASSET + 'beads-amazonite.jpg' },
            { id: 'howlite-white', name: 'הוולייט לבן', energy: 'רוגע ושלווה', colors: ['white'], energyTags: ['calm'], gradient: ['#fff','#f0ebe3','#e0dbd3'], priceAdd: 0, image: ASSET + 'beads-howlite-white.jpg' },
            { id: 'howlite-blue', name: 'הוולייט כחול', energy: 'שקט ותקשורת', colors: ['blue'], energyTags: ['calm','focus'], gradient: ['#87ceeb','#5dade2','#3498db'], priceAdd: 10, image: ASSET + 'beads-howlite-blue.jpg' },
            { id: 'howlite-turquoise', name: 'הוולייט טורקיז', energy: 'ריפוי ושקט', colors: ['blue','green'], energyTags: ['calm','healing'], gradient: ['#7fdbda','#48c9b0','#1abc9c'], priceAdd: 10, image: ASSET + 'beads-howlite-turquoise.jpg' },
            { id: 'carnelian', name: 'קרנליאן', energy: 'אומץ ויצירתיות', colors: ['red'], energyTags: ['courage','focus'], gradient: ['#e8734a','#d35400','#c0392b'], priceAdd: 15, image: ASSET + 'beads-carnelian.jpg' },
            { id: 'citrine', name: 'סיטרין', energy: 'שפע ואנרגיה', colors: ['brown'], energyTags: ['abundance','focus'], gradient: ['#f9e076','#f0c040','#d4a017'], priceAdd: 40, image: ASSET + 'beads-citrine.jpg' },
            { id: 'labradorite', name: 'לברדורייט', energy: 'אינטואיציה והגנה', colors: ['black','blue'], energyTags: ['intuition','protection'], gradient: ['#7b8fa1','#506070','#3a4a58'], priceAdd: 55, shadeNote: true, image: ASSET + 'beads-labradorite.jpg' },
            { id: 'garnet', name: 'גארנט', energy: 'אהבה ואומץ', colors: ['red'], energyTags: ['love','courage'], gradient: ['#c0392b','#922b21','#6e2c2c'], priceAdd: 45, image: ASSET + 'beads-garnet.jpg' },
            { id: 'jade', name: 'ג׳ייד', energy: 'שפע והרמוניה', colors: ['green'], energyTags: ['abundance','healing'], gradient: ['#7dcea0','#52be80','#27ae60'], priceAdd: 35, image: ASSET + 'beads-jade.jpg' },
            { id: 'obsidian', name: 'אובסידיאן', energy: 'הגנה וטיהור', colors: ['black'], energyTags: ['protection'], gradient: ['#444','#222','#111'], priceAdd: 10, image: ASSET + 'beads-obsidian.jpg' },
            { id: 'sodalite', name: 'סודלייט', energy: 'מיקוד וחוכמה', colors: ['blue'], energyTags: ['focus','intuition'], gradient: ['#4a6fa5','#2c3e6b','#1a2544'], priceAdd: 25, image: ASSET + 'beads-sodalite.jpg' },
            { id: 'rhodonite', name: 'רודונייט', energy: 'אהבה וריפוי', colors: ['pink','black'], energyTags: ['love','healing'], gradient: ['#e8829b','#c0607a','#9b4060'], priceAdd: 30, image: ASSET + 'beads-rhodonite.jpg' },
        ];
    }

    var SIZES = cleanArray(CONFIG && CONFIG.sizes) || [];
    if (SIZES.length === 0) {
        SIZES = [
            { type: 'necklace', code: '108', label: '108 חרוזים', beads: 108, basePrice: 550, description: 'מאלה מלאה • ~90 ס״מ', lengthNote: 'נופלת עד הטבור', image: (window._sizeImages && window._sizeImages['108']) || '' },
            { type: 'necklace', code: '81', label: '81 חרוזים', beads: 81, basePrice: 480, description: 'מאלה ¾ • ~68 ס״מ', lengthNote: 'נופלת עד אמצע החזה', image: (window._sizeImages && window._sizeImages['81']) || '' },
            { type: 'necklace', code: '54', label: '54 חרוזים', beads: 54, basePrice: 420, description: 'חצי מאלה • ~50 ס״מ', lengthNote: 'נופלת עד החזה העליון', image: (window._sizeImages && window._sizeImages['54']) || '' },
            { type: 'bracelet', code: 'S', label: 'S', beads: 18, basePrice: 380, description: '15 ס״מ • 18 חרוזים', lengthNote: '', image: '' },
            { type: 'bracelet', code: 'M', label: 'M', beads: 21, basePrice: 400, description: '17 ס״מ • 21 חרוזים', lengthNote: '', image: '' },
            { type: 'bracelet', code: 'L', label: 'L', beads: 24, basePrice: 420, description: '19 ס״מ • 24 חרוזים', lengthNote: '', image: '' },
            { type: 'bracelet', code: 'XL', label: 'XL', beads: 27, basePrice: 440, description: '21 ס״מ • 27 חרוזים', lengthNote: '', image: '' },
        ];
    }

    var SPACERS = cleanArray(CONFIG && CONFIG.spacers) || [];
    if (SPACERS.length === 0) {
        SPACERS = [
            { metal: 'silver', metalName: 'כסף טהור', metalColor: '#c0c0c0', metalSubtitle: 'Sterling 925 · בתוספת תשלום', coverageLevels: [
                { id: 'minimal', name: 'מינימלי (כל 27)', everyN: 'כל 27 חרוזים', price: 30 },
                { id: 'light', name: 'קלילים (כל 9)', everyN: 'כל 9 חרוזים', price: 80 },
                { id: 'medium', name: 'בינוני (כל 3)', everyN: 'כל 3 חרוזים', price: 150 },
                { id: 'full', name: 'מלא (כל חרוז)', everyN: 'בין כל חרוז', price: 300 },
            ]},
            { metal: 'gold', metalName: 'גולדפילד', metalColor: '#C9A96E', metalSubtitle: 'כסף טהור מצופה זהב · בתוספת תשלום', coverageLevels: [
                { id: 'minimal', name: 'מינימלי (כל 27)', everyN: 'כל 27 חרוזים', price: 30 },
                { id: 'light', name: 'קלילים (כל 9)', everyN: 'כל 9 חרוזים', price: 80 },
                { id: 'medium', name: 'בינוני (כל 3)', everyN: 'כל 3 חרוזים', price: 150 },
                { id: 'full', name: 'מלא (כל חרוז)', everyN: 'בין כל חרוז', price: 300 },
            ]},
            { metal: 'shiny-silver', metalName: 'כסף מבריק', metalColor: '#C0C0C0', metalSubtitle: '', coverageLevels: [
                { id: 'minimal', name: 'מינימלי (כל 27)', everyN: 'כל 27 חרוזים', price: 0 },
                { id: 'light', name: 'קלילים (כל 9)', everyN: 'כל 9 חרוזים', price: 0 },
                { id: 'medium', name: 'בינוני (כל 3)', everyN: 'כל 3 חרוזים', price: 0 },
                { id: 'full', name: 'מלא (כל חרוז)', everyN: 'בין כל חרוז', price: 0 },
            ]},
            { metal: 'shiny-black', metalName: 'שחור מבריק', metalColor: '#2a2a2a', metalSubtitle: '', coverageLevels: [
                { id: 'minimal', name: 'מינימלי (כל 27)', everyN: 'כל 27 חרוזים', price: 0 },
                { id: 'light', name: 'קלילים (כל 9)', everyN: 'כל 9 חרוזים', price: 0 },
                { id: 'medium', name: 'בינוני (כל 3)', everyN: 'כל 3 חרוזים', price: 0 },
                { id: 'full', name: 'מלא (כל חרוז)', everyN: 'בין כל חרוז', price: 0 },
            ]},
            { metal: 'dark-gray', metalName: 'אפור כהה מבריק', metalColor: '#555555', metalSubtitle: '', coverageLevels: [
                { id: 'minimal', name: 'מינימלי (כל 27)', everyN: 'כל 27 חרוזים', price: 0 },
                { id: 'light', name: 'קלילים (כל 9)', everyN: 'כל 9 חרוזים', price: 0 },
                { id: 'medium', name: 'בינוני (כל 3)', everyN: 'כל 3 חרוזים', price: 0 },
                { id: 'full', name: 'מלא (כל חרוז)', everyN: 'בין כל חרוז', price: 0 },
            ]},
            { metal: 'none', metalName: 'ללא חוצצים', metalColor: null, metalSubtitle: 'חרוזי אבן בלבד', coverageLevels: [] },
        ];
    }
    SPACERS.forEach(function(s) { s.coverageLevels = cleanArray(s.coverageLevels); });

    var GURUS = cleanArray(CONFIG && CONFIG.gurus) || [];
    if (GURUS.length === 0) {
        GURUS = [
            { id: 'classic', name: 'גורו קלאסי', description: 'חרוז אבן עגול חלק', priceAdd: 0, previewType: 'classic' },
            { id: 'sandwich', name: 'גורו סנדוויץ׳', description: 'חצי כיפה + אבן + חצי כיפה', priceAdd: 45, previewType: 'sandwich' },
            { id: 'none', name: 'ללא גורו', description: 'ללא חרוז גורו', priceAdd: 0, previewType: 'none' },
        ];
    }

    var FINISHES = cleanArray(CONFIG && CONFIG.finishes) || [];
    if (FINISHES.length === 0) {
        FINISHES = [
            { id: 'bead-continuation', name: 'המשך חרוזים', color: 'stones', kind: 'beads', priceAdd: 0, category: 'bead-continuation' },
            { id: 'tassel-brown', name: 'פונפון חום', color: '#8B6F47', kind: 'tassel', priceAdd: 35, category: 'tassel' },
            { id: 'tassel-beige', name: 'פונפון בז׳', color: '#D4C5B2', kind: 'tassel', priceAdd: 35, category: 'tassel' },
            { id: 'tassel-sage', name: 'פונפון ירוק מרווה', color: '#8B9E82', kind: 'tassel', priceAdd: 35, category: 'tassel' },
            { id: 'tassel-purple', name: 'פונפון סגול', color: '#9B7DB8', kind: 'tassel', priceAdd: 35, category: 'tassel' },
            { id: 'tassel-pink', name: 'פונפון ורוד', color: '#D4A0A0', kind: 'tassel', priceAdd: 35, category: 'tassel' },
            { id: 'tassel-white', name: 'פונפון לבן', color: '#F0EBE3', kind: 'tassel', priceAdd: 35, category: 'tassel' },
            { id: 'pendant-lotus', name: 'תליון לוטוס', color: '#C9A96E', kind: 'pendant', priceAdd: 45, category: 'pendant' },
            { id: 'pendant-tree', name: 'תליון עץ חיים', color: '#8B9E82', kind: 'pendant', priceAdd: 45, category: 'pendant' },
            { id: 'pendant-om', name: 'תליון Om', color: '#C9A96E', kind: 'pendant', priceAdd: 45, category: 'pendant' },
        ];
    }

    var SPACER_COLORS = {};
    SPACERS.forEach(function(s) { SPACER_COLORS[s.metal] = s.metalColor; });

    var COVERAGE_MAP = {};
    SPACERS.forEach(function(s) { s.coverageLevels.forEach(function(c) { if (!COVERAGE_MAP[c.id]) COVERAGE_MAP[c.id] = c.name; }); });

    var GURU_MAP = {};
    GURUS.forEach(function(g) { GURU_MAP[g.id] = g.name; });

    var FINISH_MAP = {};
    FINISHES.forEach(function(f) { FINISH_MAP[f.id] = f.name; });

    var state = {
        currentStep: 'typeSize',
        type: null,
        size: null,
        closure: null,
        beadCount: 0,
        basePrice: 0,
        selectedStones: [],
        spacerMetal: null,
        spacerCoverage: null,
        spacerPrice: 0,
        guru: null,
        guruPrice: 0,
        finish: null,
        finishColor: null,
        finishKind: null,
        finishPrice: 0,
        arrangement: 'sequential',
        gradientOrder: [],
        guruStone: null,
    };

    // ---- Dynamic step machinery ----
    // Logical step keys mapped to their DOM ids + progress labels.
    var STEP_ORDER_ALL = ['typeSize', 'closure', 'stones', 'spacers', 'guru', 'finish'];
    var STEP_DOM = { typeSize: 'step1', closure: 'stepClosure', stones: 'step2', spacers: 'step3', guru: 'step4', finish: 'step5' };
    var STEP_LABEL = { typeSize: 'סוג וגודל', closure: 'סגירה', stones: 'אבנים', spacers: 'חוצצים', guru: 'גורו', finish: 'סיום' };

    function activeSteps() {
        var keys = ['typeSize', 'closure', 'stones', 'spacers'];
        if (state.closure !== 'infinity') keys.push('guru', 'finish');
        return keys;
    }
    function isLastStep(key) { var a = activeSteps(); return a.indexOf(key) === a.length - 1; }

    function getStoneById(id) { return STONES.find(function(s) { return s.id === id; }); }

    function getPrice() {
        var p = state.basePrice + state.spacerPrice + state.guruPrice + state.finishPrice;
        state.selectedStones.forEach(function(id) { var s = getStoneById(id); if (s) p += s.priceAdd; });
        return p;
    }

    // ---- Dynamic UI Rendering ----
    function renderStep1() {
        var necklaceSizes = SIZES.filter(function(s) { return s.type === 'necklace'; });
        var braceletSizes = SIZES.filter(function(s) { return s.type === 'bracelet'; });
        var nContainer = document.getElementById('necklaceSizes');
        var bContainer = document.getElementById('braceletSizes');
        if (!nContainer || !bContainer) return;

        var nGrid = nContainer.querySelector('.size-grid');
        var bGrid = bContainer.querySelector('.size-grid');
        if (!nGrid || !bGrid) return;

        nGrid.innerHTML = '';
        necklaceSizes.forEach(function(sz) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'size-option group relative bg-white rounded-2xl p-6 border-2 border-sand hover:border-terracotta transition-all text-center';
            btn.dataset.size = sz.code;
            btn.dataset.beads = sz.beads;
            btn.dataset.price = sz.basePrice;
            var imgHtml = sz.image
                ? '<div class="relative overflow-hidden rounded-xl mb-4"><img src="' + sz.image + '" alt="' + sz.label + '" class="w-full h-48 object-cover rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"><div class="absolute inset-0 flex items-center justify-center group-hover:opacity-0 transition-opacity duration-300 bg-sand-light rounded-xl"><span class="text-6xl font-bold text-terracotta/20">' + sz.code + '</span></div></div>'
                : '<div class="flex items-center justify-center h-20 mb-4 bg-sand-light rounded-xl"><span class="text-5xl font-bold text-terracotta/20">' + sz.code + '</span></div>';
            btn.innerHTML = imgHtml +
                '<h4 class="font-bold text-xl text-brown-dark mb-1">' + sz.label + '</h4>' +
                '<p class="text-sm text-warm-gray mb-1">' + (sz.description || '') + '</p>' +
                (sz.lengthNote ? '<p class="text-sm text-warm-gray/70">' + sz.lengthNote + '</p>' : '') +
                '<p class="text-lg font-bold text-terracotta mt-2">₪' + sz.basePrice + '</p>';
            btn.addEventListener('click', function() {
                selectInGroup(nContainer, '.size-option', btn);
                state.size = sz.code;
                state.beadCount = sz.beads;
                state.basePrice = sz.basePrice;
                updateSummary(); updatePreview(); updateNavState();
            });
            nGrid.appendChild(btn);
        });

        bGrid.innerHTML = '';
        braceletSizes.forEach(function(sz) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'size-option bg-white rounded-2xl p-6 border-2 border-sand hover:border-terracotta transition-all text-center';
            btn.dataset.size = sz.code;
            btn.dataset.beads = sz.beads;
            btn.dataset.price = sz.basePrice;
            btn.innerHTML =
                '<div class="w-14 h-14 rounded-full bg-sand-light flex items-center justify-center mx-auto mb-3"><span class="text-2xl font-bold text-terracotta">' + sz.code + '</span></div>' +
                '<h4 class="font-bold text-lg text-brown-dark">' + sz.code + '</h4>' +
                '<p class="text-sm text-warm-gray">' + (sz.description || '') + '</p>' +
                '<p class="text-base font-bold text-terracotta mt-2">₪' + sz.basePrice + '</p>';
            btn.addEventListener('click', function() {
                selectInGroup(bContainer, '.size-option', btn);
                state.size = sz.code;
                state.beadCount = sz.beads;
                state.basePrice = sz.basePrice;
                updateSummary(); updatePreview(); updateNavState();
            });
            bGrid.appendChild(btn);
        });

        var minNecklace = necklaceSizes.length > 0 ? Math.min.apply(null, necklaceSizes.map(function(s) { return s.basePrice; })) : 550;
        var minBracelet = braceletSizes.length > 0 ? Math.min.apply(null, braceletSizes.map(function(s) { return s.basePrice; })) : 380;
        var nPrice = document.getElementById('necklaceStartPrice');
        var bPrice = document.getElementById('braceletStartPrice');
        if (nPrice) nPrice.textContent = '₪' + minNecklace;
        if (bPrice) bPrice.textContent = '₪' + minBracelet;
    }

    function renderStep3() {
        var container = document.getElementById('spacerMetalGrid');
        if (!container) return;
        container.innerHTML = '';

        SPACERS.forEach(function(sp) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'spacer-metal-option bg-white rounded-2xl p-6 border-2 border-sand hover:border-terracotta transition-all text-center';
            btn.dataset.metal = sp.metal;

            var circleHtml;
            if (sp.metal === 'none') {
                circleHtml = '<div class="w-14 h-14 rounded-full mx-auto mb-3 border-2 border-dashed border-sand bg-sand-light flex items-center justify-center"><svg class="w-6 h-6 text-warm-gray" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/></svg></div>';
            } else {
                var gradColors;
                if (sp.metal === 'gold') gradColors = 'linear-gradient(135deg, #ffd700, ' + sp.metalColor + ', #b8860b)';
                else if (sp.metal === 'shiny-black') gradColors = 'linear-gradient(135deg, #555, ' + sp.metalColor + ', #111)';
                else if (sp.metal === 'dark-gray') gradColors = 'linear-gradient(135deg, #888, ' + sp.metalColor + ', #333)';
                else gradColors = 'linear-gradient(135deg, #e8e8e8, ' + sp.metalColor + ', #a8a8a8)';
                circleHtml = '<div class="w-14 h-14 rounded-full mx-auto mb-3" style="background: ' + gradColors + ';"></div>';
            }

            btn.innerHTML = circleHtml +
                '<h4 class="font-bold text-lg text-brown-dark">' + sp.metalName + '</h4>' +
                '<p class="text-sm text-warm-gray">' + (sp.metalSubtitle || '') + '</p>';

            btn.addEventListener('click', function() {
                selectInGroup(document.getElementById('step3'), '.spacer-metal-option', btn);
                state.spacerMetal = sp.metal;
                state.spacerCoverage = null;
                state.spacerPrice = 0;
                renderCoverageOptions(sp);
                var coverageDiv = document.getElementById('spacerCoverage');
                if (sp.metal !== 'none' && sp.coverageLevels.length > 0) coverageDiv.classList.remove('hidden');
                else coverageDiv.classList.add('hidden');
                updateSummary(); updatePreview(); updateNavState();
            });
            container.appendChild(btn);
        });
    }

    function renderCoverageOptions(spacer) {
        var grid = document.getElementById('coverageGrid');
        if (!grid) return;
        grid.innerHTML = '';

        spacer.coverageLevels.forEach(function(cov) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'coverage-option bg-white rounded-2xl p-5 border-2 border-sand hover:border-terracotta transition-all text-center';
            btn.dataset.coverage = cov.id;
            btn.dataset.spacerPrice = cov.price;
            var priceLabel = cov.price > 0 ? '<p class="text-sm font-bold text-terracotta">+₪' + cov.price + '</p>' : '<p class="text-sm font-bold text-sage">כלול במחיר</p>';
            btn.innerHTML =
                '<h4 class="font-bold text-brown-dark mb-1">' + cov.name + '</h4>' +
                '<p class="text-xs text-warm-gray mb-2">' + (cov.everyN || '') + '</p>' +
                priceLabel;
            btn.addEventListener('click', function() {
                selectInGroup(document.getElementById('spacerCoverage'), '.coverage-option', btn);
                state.spacerCoverage = cov.id;
                state.spacerPrice = cov.price;
                updateSummary(); updatePreview(); updateNavState();
            });
            grid.appendChild(btn);
        });
    }

    function renderStep4() {
        var container = document.getElementById('guruGrid');
        if (!container) return;
        container.innerHTML = '';

        GURUS.forEach(function(g) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'guru-option bg-white rounded-2xl p-6 border-2 border-sand hover:border-terracotta transition-all text-center';
            btn.dataset.guru = g.id;
            btn.dataset.priceAdd = g.priceAdd;

            var previewHtml;
            if (g.previewType === 'sandwich') {
                previewHtml = '<div class="w-20 h-20 mx-auto mb-4 flex flex-col items-center justify-center gap-0.5">' +
                    '<div class="w-10 h-3 rounded-t-full guru-sandwich-top" style="background: linear-gradient(135deg, #e8e8e8, #c0c0c0);"></div>' +
                    '<div class="w-10 h-8 rounded-full guru-sandwich-stone" style="background: radial-gradient(circle at 35% 35%, #ddd, #bbb, #999);"></div>' +
                    '<div class="w-10 h-3 rounded-b-full guru-sandwich-bottom" style="background: linear-gradient(135deg, #e8e8e8, #c0c0c0);"></div></div>';
            } else if (g.previewType === 'none') {
                previewHtml = '<div class="w-20 h-20 mx-auto mb-4 flex items-center justify-center"><div class="w-14 h-14 rounded-full border-2 border-dashed border-sand bg-sand-light flex items-center justify-center"><svg class="w-6 h-6 text-warm-gray" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/></svg></div></div>';
            } else {
                previewHtml = '<div class="w-20 h-20 mx-auto mb-4 flex items-center justify-center"><div class="w-14 h-14 rounded-full shadow-md border-2 border-white guru-classic-preview" style="background: radial-gradient(circle at 35% 35%, #ddd, #bbb, #999);"></div></div>';
            }

            var priceHtml = g.priceAdd > 0 ? '<p class="text-sm font-bold text-terracotta">+₪' + g.priceAdd + '</p>' : '<p class="text-sm text-warm-gray/50">—</p>';
            btn.innerHTML = previewHtml +
                '<h4 class="font-bold text-lg text-brown-dark mb-1">' + g.name + '</h4>' +
                '<p class="text-sm text-warm-gray mb-2">' + (g.description || '') + '</p>' +
                priceHtml;

            btn.addEventListener('click', function() {
                selectInGroup(document.getElementById('step4'), '.guru-option', btn);
                state.guru = g.id;
                state.guruPrice = g.priceAdd;
                renderGuruStoneSelector();
                updateSummary(); updatePreview(); updateNavState();
            });
            container.appendChild(btn);
        });
    }

    function renderGuruStoneSelector() {
        var section = document.getElementById('guruStoneSection');
        var grid = document.getElementById('guruStoneGrid');
        if (!section || !grid) return;

        if (!state.guru || state.guru === 'none' || state.selectedStones.length === 0) {
            section.classList.add('hidden');
            return;
        }
        section.classList.remove('hidden');
        grid.innerHTML = '';

        var defaultBtn = document.createElement('button');
        defaultBtn.type = 'button';
        defaultBtn.className = 'guru-stone-btn flex flex-col items-center gap-1 p-3 rounded-xl border-2 transition-all ' +
            (!state.guruStone ? 'border-terracotta shadow-lg ring-2 ring-terracotta/30' : 'border-sand hover:border-terracotta');
        defaultBtn.dataset.guruStone = '';
        defaultBtn.innerHTML =
            '<div class="w-10 h-10 rounded-full bg-gradient-to-br from-sand-light to-sand flex items-center justify-center text-xs font-bold text-warm-gray">⟳</div>' +
            '<span class="text-xs font-medium text-brown-dark">זהה לשרשרת</span>';
        defaultBtn.addEventListener('click', function() {
            state.guruStone = null;
            renderGuruStoneSelector();
            updatePreview();
        });
        grid.appendChild(defaultBtn);

        state.selectedStones.forEach(function(id) {
            var s = getStoneById(id);
            if (!s) return;
            var btn = document.createElement('button');
            btn.type = 'button';
            var isActive = state.guruStone === id;
            btn.className = 'guru-stone-btn flex flex-col items-center gap-1 p-3 rounded-xl border-2 transition-all ' +
                (isActive ? 'border-terracotta shadow-lg ring-2 ring-terracotta/30' : 'border-sand hover:border-terracotta');
            btn.dataset.guruStone = id;
            btn.innerHTML =
                '<div class="w-10 h-10 rounded-full shadow-inner" style="background: radial-gradient(circle at 35% 35%, ' + s.gradient.join(',') + ')"></div>' +
                '<span class="text-xs font-medium text-brown-dark">' + s.name + '</span>';
            btn.addEventListener('click', function() {
                state.guruStone = id;
                renderGuruStoneSelector();
                updatePreview();
            });
            grid.appendChild(btn);
        });
    }

    function renderStep5() {
        var tassels = FINISHES.filter(function(f) { return f.category === 'tassel'; });
        var beadCont = FINISHES.filter(function(f) { return f.category === 'bead-continuation'; });
        var pendants = FINISHES.filter(function(f) { return f.category === 'pendant'; });

        var tasselGrid = document.getElementById('tasselGrid');
        var beadContGrid = document.getElementById('beadContGrid');
        var pendantGrid = document.getElementById('pendantGrid');
        if (!tasselGrid || !beadContGrid || !pendantGrid) return;

        tasselGrid.innerHTML = '';
        tassels.forEach(function(f) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'finish-option flex flex-col items-center gap-2 p-4 rounded-xl border-2 border-sand bg-white hover:border-terracotta transition-all';
            btn.dataset.finish = f.id;
            btn.dataset.finishColor = f.color;
            btn.dataset.finishKind = f.kind;
            btn.dataset.priceAdd = f.priceAdd;
            var lightColor = lightenColor(f.color, 20);
            btn.innerHTML =
                '<div class="w-10 h-16 rounded-b-full relative" style="background: linear-gradient(to bottom, ' + lightColor + ', ' + f.color + ');"><div class="absolute top-0 left-1/2 -translate-x-1/2 w-5 h-2 rounded-t-full bg-warm-gray/30"></div></div>' +
                '<span class="text-sm font-medium">' + f.name.replace('פונפון ', '') + '</span>' +
                (f.priceAdd > 0 ? '<span class="text-xs font-bold text-terracotta">+₪' + f.priceAdd + '</span>' : '');
            btn.addEventListener('click', function() { selectFinish(f); });
            tasselGrid.appendChild(btn);
        });

        beadContGrid.innerHTML = '';
        beadCont.forEach(function(f) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'finish-option inline-flex items-center gap-2 bg-terracotta/10 text-terracotta px-6 py-3 rounded-xl font-semibold hover:bg-terracotta/20 transition-all border-2 border-transparent';
            btn.dataset.finish = f.id;
            btn.dataset.finishColor = f.color;
            btn.dataset.finishKind = f.kind;
            btn.dataset.priceAdd = f.priceAdd;
            btn.textContent = f.name + (f.priceAdd > 0 ? ' • +₪' + f.priceAdd : ' • כלול במחיר');
            btn.addEventListener('click', function() { selectFinish(f); });
            beadContGrid.appendChild(btn);
        });

        pendantGrid.innerHTML = '';
        var pendantIcons = { 'pendant-lotus': '<svg class="w-8 h-8 text-gold" viewBox="0 0 32 32" fill="currentColor"><path d="M16 4c-2 4-6 8-6 14 0 4 2.5 7 6 7s6-3 6-7c0-6-4-10-6-14z" opacity="0.3"/><path d="M16 8c-1.5 3-4 6-4 10 0 3 1.5 5 4 5s4-2 4-5c0-4-2.5-7-4-10z" opacity="0.5"/><path d="M16 12c-1 2-2.5 4-2.5 7 0 2 1 3.5 2.5 3.5s2.5-1.5 2.5-3.5c0-3-1.5-5-2.5-7z"/></svg>', 'pendant-tree': '<svg class="w-8 h-8 text-sage" viewBox="0 0 32 32" fill="currentColor"><circle cx="16" cy="14" r="10" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M16 24v4M16 14c-3-3-5-6-5-8M16 14c3-3 5-6 5-8M16 14c-2 2-4 5-5 8M16 14c2 2 4 5 5 8M16 14v-8M12 10c2 0 4 2 4 4M20 10c-2 0-4 2-4 4"/></svg>', 'pendant-om': '<span class="text-3xl font-serif text-gold font-bold">ॐ</span>' };
        pendants.forEach(function(f) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'finish-option bg-white rounded-2xl p-6 border-2 border-sand hover:border-terracotta transition-all text-center';
            btn.dataset.finish = f.id;
            btn.dataset.finishColor = f.color;
            btn.dataset.finishKind = f.kind;
            btn.dataset.priceAdd = f.priceAdd;
            var icon = pendantIcons[f.id] || '<span class="text-3xl text-gold">●</span>';
            btn.innerHTML =
                '<div class="w-16 h-16 mx-auto mb-3 rounded-full bg-sand-light flex items-center justify-center">' + icon + '</div>' +
                '<h4 class="font-bold text-lg text-brown-dark mb-1">' + f.name + '</h4>' +
                (f.priceAdd > 0 ? '<p class="text-sm font-bold text-terracotta">+₪' + f.priceAdd + '</p>' : '<p class="text-sm text-warm-gray/50">—</p>');
            btn.addEventListener('click', function() { selectFinish(f); });
            pendantGrid.appendChild(btn);
        });
    }

    function selectFinish(f) {
        document.querySelectorAll('.finish-option').forEach(function(b) { b.classList.remove('border-terracotta','shadow-lg','ring-2','ring-terracotta/30'); });
        var selected = document.querySelector('.finish-option[data-finish="' + f.id + '"]');
        if (selected) selected.classList.add('border-terracotta','shadow-lg','ring-2','ring-terracotta/30');
        state.finish = f.id;
        state.finishColor = f.color;
        state.finishKind = f.kind;
        state.finishPrice = f.priceAdd;
        updateSummary(); updatePreview(); updateNavState();
    }

    function lightenColor(hex, percent) {
        if (!hex || hex === 'stones') return '#E8DDD3';
        hex = hex.replace('#', '');
        if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        var r = parseInt(hex.substring(0,2),16), g = parseInt(hex.substring(2,4),16), b = parseInt(hex.substring(4,6),16);
        r = Math.min(255, r + Math.round((255 - r) * percent / 100));
        g = Math.min(255, g + Math.round((255 - g) * percent / 100));
        b = Math.min(255, b + Math.round((255 - b) * percent / 100));
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    // ---- Render Stones Grid ----
    function renderStonesGrid(filter, filterType) {
        var grid = document.getElementById('stonesGrid');
        grid.innerHTML = '';
        STONES.forEach(function(stone) {
            var visible = true;
            if (filter && filter !== 'all') {
                if (filterType === 'color') visible = stone.colors.indexOf(filter) > -1;
                else if (filterType === 'energy') visible = stone.energyTags.indexOf(filter) > -1;
            }
            var isSelected = state.selectedStones.indexOf(stone.id) > -1;
            var card = document.createElement('button');
            card.type = 'button';
            card.className = 'stone-card bg-white rounded-2xl p-4 border-2 transition-all text-center relative ' +
                (isSelected ? 'border-terracotta shadow-lg ring-2 ring-terracotta/30' : 'border-sand hover:border-terracotta/50') +
                (visible ? '' : ' opacity-30 pointer-events-none');
            card.dataset.stoneId = stone.id;

            var gradStyle = 'background: radial-gradient(circle at 35% 35%, ' + stone.gradient.join(',') + ')';
            var shadeIcon = stone.shadeNote ? '<span class="absolute top-2 left-2 text-xs bg-gold/20 text-gold px-1.5 py-0.5 rounded-full" title="גוון עשוי להשתנות טבעית">~</span>' : '';
            var checkMark = isSelected ? '<div class="absolute top-2 right-2 w-6 h-6 bg-terracotta rounded-full flex items-center justify-center"><svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg></div>' : '';

            card.innerHTML = checkMark + shadeIcon +
                '<div class="flex items-center justify-center gap-3 mb-3">' +
                    '<div class="bead-zoom-trigger relative cursor-zoom-in" data-stone-id="' + stone.id + '">' +
                        '<img src="' + (stone.image || '') + '" alt="' + stone.name + '" class="w-12 h-12 rounded-full object-cover shadow-inner" loading="lazy">' +
                        '<span class="bead-zoom-icon"><svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg></span>' +
                    '</div>' +
                    '<div class="w-12 h-12 rounded-full shadow-inner flex-shrink-0" style="' + gradStyle + '"></div>' +
                '</div>' +
                '<h4 class="font-bold text-sm text-brown-dark mb-0.5">' + stone.name + '</h4>' +
                '<p class="text-xs text-warm-gray">' + stone.energy + '</p>' +
                (stone.priceAdd > 0 ? '<p class="text-xs text-terracotta mt-1 font-semibold">+₪' + stone.priceAdd + '</p>' : '');

            var zoomTrigger = card.querySelector('.bead-zoom-trigger');
            zoomTrigger.addEventListener('click', function(e) { e.stopPropagation(); showBeadZoom(stone); });
            card.addEventListener('click', function() { toggleStone(stone.id); });
            grid.appendChild(card);
        });
    }

    function toggleStone(id) {
        var idx = state.selectedStones.indexOf(id);
        if (idx > -1) state.selectedStones.splice(idx, 1);
        else state.selectedStones.push(id);
        syncGradientOrder();
        var activeFilter = document.querySelector('.filter-chip.active');
        renderStonesGrid(activeFilter ? activeFilter.dataset.filter : 'all', activeFilter ? activeFilter.dataset.filterType : 'color');
        updateSelectedBar();
        renderGradientOrder();
        updateSummary();
        updatePreview();
        updateNavState();
    }

    function showBeadZoom(stone) {
        var lb = document.getElementById('beadLightbox');
        document.getElementById('beadLightboxImg').src = stone.image || '';
        document.getElementById('beadLightboxImg').alt = stone.name;
        document.getElementById('beadLightboxName').textContent = stone.name;
        document.getElementById('beadLightboxEnergy').textContent = stone.energy;
        var shadeEl = document.getElementById('beadLightboxShade');
        if (stone.shadeNote) shadeEl.classList.remove('hidden');
        else shadeEl.classList.add('hidden');
        lb.classList.remove('hidden');
        requestAnimationFrame(function() { lb.classList.add('active'); });
        document.body.style.overflow = 'hidden';
    }

    function hideBeadZoom() {
        var lb = document.getElementById('beadLightbox');
        lb.classList.remove('active');
        setTimeout(function() {
            lb.classList.add('hidden');
            document.body.style.overflow = '';
        }, 300);
    }

    window.hideBeadZoom = hideBeadZoom;

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') hideBeadZoom();
    });

    function syncGradientOrder() {
        var current = state.gradientOrder.slice();
        var newOrder = [];
        current.forEach(function(id) {
            if (state.selectedStones.indexOf(id) > -1) newOrder.push(id);
        });
        state.selectedStones.forEach(function(id) {
            if (newOrder.indexOf(id) === -1) newOrder.push(id);
        });
        state.gradientOrder = newOrder;
    }

    var _pendingSwapIdx = -1;

    function renderGradientOrder() {
        var section = document.getElementById('gradientOrderSection');
        var list = document.getElementById('gradientOrderList');
        var label = document.getElementById('gradientOrderLabel');
        if (!section || !list) return;
        if (state.arrangement !== 'gradient' || state.selectedStones.length < 2) {
            section.classList.add('hidden');
            _pendingSwapIdx = -1;
            return;
        }
        syncGradientOrder();
        section.classList.remove('hidden');
        list.innerHTML = '';

        if (label) {
            label.textContent = _pendingSwapIdx >= 0
                ? 'בחרו אבן שניה להחלפה'
                : 'סדר הצבעים (מלמטה למעלה) · לחצו על 2 אבנים להחלפת מיקום';
        }

        state.gradientOrder.forEach(function(id, idx) {
            var s = getStoneById(id);
            if (!s) return;
            var isPending = idx === _pendingSwapIdx;
            var item = document.createElement('button');
            item.type = 'button';
            item.className = 'flex flex-col items-center gap-1 p-2 rounded-xl border-2 transition-all cursor-pointer min-w-[52px] ' +
                (isPending ? 'border-terracotta ring-2 ring-terracotta/30 bg-terracotta/5 scale-105' : 'border-sand bg-white hover:border-terracotta/50');

            var num = document.createElement('span');
            num.className = 'text-[9px] font-bold text-warm-gray';
            num.textContent = (idx + 1);
            item.appendChild(num);

            var swatch = document.createElement('span');
            swatch.className = 'w-7 h-7 rounded-full shadow-sm';
            swatch.style.background = 'radial-gradient(circle at 35% 35%, ' + s.gradient.join(',') + ')';
            item.appendChild(swatch);

            var name = document.createElement('span');
            name.className = 'text-[10px] font-medium text-brown-dark leading-tight text-center';
            name.textContent = s.name;
            item.appendChild(name);

            item.addEventListener('click', function() {
                if (_pendingSwapIdx < 0) {
                    _pendingSwapIdx = idx;
                    renderGradientOrder();
                } else if (_pendingSwapIdx === idx) {
                    _pendingSwapIdx = -1;
                    renderGradientOrder();
                } else {
                    var arr = state.gradientOrder;
                    var tmp = arr[_pendingSwapIdx];
                    arr[_pendingSwapIdx] = arr[idx];
                    arr[idx] = tmp;
                    _pendingSwapIdx = -1;
                    renderGradientOrder();
                    updatePreview();
                }
            });

            list.appendChild(item);

            if (idx < state.gradientOrder.length - 1) {
                var arrow = document.createElement('span');
                arrow.className = 'text-warm-gray/40 text-xs self-center';
                arrow.textContent = '→';
                list.appendChild(arrow);
            }
        });
    }

    // Arrangement buttons
    document.querySelectorAll('.arrangement-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.arrangement-btn').forEach(function(b) {
                b.classList.remove('border-terracotta', 'shadow-lg', 'ring-2', 'ring-terracotta/30');
                b.classList.add('border-sand');
            });
            btn.classList.add('border-terracotta', 'shadow-lg', 'ring-2', 'ring-terracotta/30');
            btn.classList.remove('border-sand');
            state.arrangement = btn.dataset.arrangement;
            renderGradientOrder();
            updatePreview();
        });
    });

    function updateSelectedBar() {
        var bar = document.getElementById('selectedStonesBar');
        var chips = document.getElementById('selectedStoneChips');
        var count = document.getElementById('selectedCount');
        var arrangementSection = document.getElementById('arrangementSection');
        if (state.selectedStones.length === 0) {
            bar.classList.add('hidden');
            if (arrangementSection) arrangementSection.classList.add('hidden');
            return;
        }
        bar.classList.remove('hidden');
        if (arrangementSection) {
            if (state.selectedStones.length > 1) arrangementSection.classList.remove('hidden');
            else arrangementSection.classList.add('hidden');
        }
        count.textContent = state.selectedStones.length;
        chips.innerHTML = '';
        state.selectedStones.forEach(function(id) {
            var s = getStoneById(id);
            if (!s) return;
            var chip = document.createElement('span');
            chip.className = 'inline-flex items-center gap-1.5 bg-sand px-3 py-1.5 rounded-full text-sm font-medium text-brown-dark';
            chip.innerHTML = '<span class="w-3 h-3 rounded-full inline-block" style="background:' + s.gradient[1] + '"></span>' +
                s.name + '<button type="button" class="text-warm-gray hover:text-terracotta text-lg leading-none" data-remove="' + id + '">&times;</button>';
            chip.querySelector('button').addEventListener('click', function(e) { e.stopPropagation(); toggleStone(id); });
            chips.appendChild(chip);
        });
    }

    // ---- Filter Logic ----
    function setupFilters() {
        var colorBtn = document.getElementById('filterByColor');
        var energyBtn = document.getElementById('filterByEnergy');
        var colorFilters = document.getElementById('colorFilters');
        var energyFilters = document.getElementById('energyFilters');

        if (!colorBtn || !energyBtn) return;

        colorBtn.addEventListener('click', function() {
            colorBtn.classList.add('bg-white','text-brown-dark','shadow-sm');
            colorBtn.classList.remove('text-warm-gray');
            energyBtn.classList.remove('bg-white','text-brown-dark','shadow-sm');
            energyBtn.classList.add('text-warm-gray');
            colorFilters.classList.remove('hidden');
            colorFilters.classList.add('flex');
            energyFilters.classList.add('hidden');
            energyFilters.classList.remove('flex');
            renderStonesGrid('all', 'color');
            colorFilters.querySelectorAll('.filter-chip').forEach(function(c) { c.classList.remove('active'); });
            colorFilters.querySelector('[data-filter="all"]').classList.add('active');
        });

        energyBtn.addEventListener('click', function() {
            energyBtn.classList.add('bg-white','text-brown-dark','shadow-sm');
            energyBtn.classList.remove('text-warm-gray');
            colorBtn.classList.remove('bg-white','text-brown-dark','shadow-sm');
            colorBtn.classList.add('text-warm-gray');
            energyFilters.classList.remove('hidden');
            energyFilters.classList.add('flex');
            colorFilters.classList.add('hidden');
            colorFilters.classList.remove('flex');
            renderStonesGrid('all', 'energy');
            energyFilters.querySelectorAll('.filter-chip').forEach(function(c) { c.classList.remove('active'); });
            energyFilters.querySelector('[data-filter="all"]').classList.add('active');
        });

        document.querySelectorAll('.filter-chip').forEach(function(chip) {
            chip.addEventListener('click', function() {
                var parent = chip.closest('#colorFilters, #energyFilters');
                parent.querySelectorAll('.filter-chip').forEach(function(c) { c.classList.remove('active'); });
                chip.classList.add('active');
                renderStonesGrid(chip.dataset.filter, chip.dataset.filterType);
            });
        });
    }

    // ---- Summary ----
    function updateSummary() {
        document.getElementById('summaryType').textContent = state.type === 'necklace' ? 'שרשרת' : state.type === 'bracelet' ? 'צמיד' : '—';
        document.getElementById('summarySize').textContent = state.size ? (state.beadCount + ' חרוזים' + (state.type === 'bracelet' ? ' (' + state.size + ')' : '')) : '—';
        var closureLabel = state.closure === 'infinity' ? 'אינפיניטי' : (state.closure === 'bead' ? 'סגירת חרוז' : '—');
        var closureEl = document.getElementById('summaryClosure');
        if (closureEl) closureEl.textContent = closureLabel;
        var mobileClosureEl = document.getElementById('mobileSummaryClosure');
        if (mobileClosureEl) mobileClosureEl.textContent = closureLabel;
        var stoneNames = state.selectedStones.map(function(id) { var s = getStoneById(id); return s ? s.name : ''; }).join(', ');
        document.getElementById('summaryStones').textContent = stoneNames || '—';
        document.getElementById('summaryStones').title = stoneNames;
        if (state.spacerMetal === 'none' || !state.spacerMetal) {
            document.getElementById('summarySpacer').textContent = state.spacerMetal === 'none' ? 'ללא' : '—';
        } else {
            var metalObj = SPACERS.find(function(s) { return s.metal === state.spacerMetal; });
            var metalName = metalObj ? metalObj.metalName : state.spacerMetal;
            var covName = state.spacerCoverage ? (COVERAGE_MAP[state.spacerCoverage] || state.spacerCoverage) : '';
            document.getElementById('summarySpacer').textContent = covName ? metalName + ' • ' + covName : metalName;
        }
        document.getElementById('summaryGuru').textContent = state.guru ? (GURU_MAP[state.guru] || state.guru) : '—';
        document.getElementById('summaryFinish').textContent = state.finish ? (FINISH_MAP[state.finish] || state.finish) : '—';
        document.getElementById('summaryPrice').textContent = '₪' + getPrice();

        // Sync mobile sticky preview
        var mobilePriceEl = document.getElementById('mobileSummaryPrice');
        if (mobilePriceEl) mobilePriceEl.textContent = '₪' + getPrice();
        var mobileBrief = document.getElementById('mobileSummaryBrief');
        if (mobileBrief) {
            var parts = [];
            if (state.type) parts.push(state.type === 'necklace' ? 'שרשרת' : 'צמיד');
            if (stoneNames) parts.push(stoneNames.split(',').length + ' אבנים');
            mobileBrief.textContent = parts.length > 0 ? parts.join(' • ') : 'בחרו סוג וגודל להתחלה';
        }
    }

    // ---- Preview ----
    function svgEl(tag, attrs) {
        var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
        for (var k in attrs) el.setAttribute(k, attrs[k]);
        return el;
    }

    function updatePreview() {
        var beadsG = document.getElementById('previewBeads');
        var guruG = document.getElementById('previewGuru');
        var tasselG = document.getElementById('previewTassel');
        beadsG.innerHTML = ''; guruG.innerHTML = ''; tasselG.innerHTML = '';

        var cx = 160, cy = 170;
        var isNecklace = state.type !== 'bracelet';
        var isInfinity = state.closure === 'infinity';
        var totalBeads = state.beadCount || 36;
        var displayBeads = isNecklace ? Math.min(totalBeads, 108) : Math.min(totalBeads, 27);
        var rx = isNecklace ? 110 : 90, ry = isNecklace ? 130 : 100;
        var beadR = isNecklace ? (displayBeads > 80 ? 4.5 : displayBeads > 54 ? 5.5 : displayBeads > 40 ? 6.5 : 7.5) : 8;

        var stoneOrder = (state.arrangement === 'gradient' && state.gradientOrder.length > 0) ? state.gradientOrder : state.selectedStones;
        var stoneGradients = stoneOrder.map(function(id) {
            var s = getStoneById(id);
            return s ? s.gradient : null;
        }).filter(Boolean);
        var defaultGrad = [['#E8DDD3','#d4c5b2','#c0b09e']];
        var grads = stoneGradients.length > 0 ? stoneGradients : defaultGrad;

        var spacerColor = SPACER_COLORS[state.spacerMetal] || null;
        var spacerEvery = 0;
        if (spacerColor && state.spacerCoverage) {
            var covMap = { minimal: 27, light: 9, medium: 3, full: 1 };
            spacerEvery = covMap[state.spacerCoverage] || 0;
        }

        var gapAngle = isNecklace ? 0.4 : 0.25;
        if (isInfinity) gapAngle = 0; // continuous closed loop, no clasp/head bead
        var arcStart = -Math.PI / 2 + gapAngle;
        var arcEnd = -Math.PI / 2 + Math.PI * 2 - gapAngle;
        var arcRange = arcEnd - arcStart;
        var startAngle = -Math.PI / 2;

        // Bracelet clasp at the top
        if (!isNecklace && gapAngle > 0) {
            var bFirstAngle = arcStart + (0.5 / displayBeads) * arcRange;
            var bLastAngle = arcStart + ((displayBeads - 0.5) / displayBeads) * arcRange;
            var bRight = { x: cx + rx * Math.cos(bFirstAngle), y: cy + ry * Math.sin(bFirstAngle) };
            var bLeft = { x: cx + rx * Math.cos(bLastAngle), y: cy + ry * Math.sin(bLastAngle) };
            var claspY = cy - ry - 4;

            var clGrad = svgEl('linearGradient', { id: 'claspGrad', x1: '0', y1: '0', x2: '0', y2: '1' });
            clGrad.appendChild(svgEl('stop', { offset: '0%', 'stop-color': '#E8E0D0' }));
            clGrad.appendChild(svgEl('stop', { offset: '100%', 'stop-color': '#C9A96E' }));
            beadsG.appendChild(clGrad);

            beadsG.appendChild(svgEl('line', { x1: bLeft.x, y1: bLeft.y, x2: cx - 6, y2: claspY + 4, stroke: '#8B7355', 'stroke-width': '0.8' }));
            beadsG.appendChild(svgEl('line', { x1: bRight.x, y1: bRight.y, x2: cx + 6, y2: claspY + 4, stroke: '#8B7355', 'stroke-width': '0.8' }));

            beadsG.appendChild(svgEl('rect', { x: cx - 8, y: claspY, width: 16, height: 6, rx: 2, fill: 'url(#claspGrad)', stroke: '#A0794E', 'stroke-width': '0.5' }));

            beadsG.appendChild(svgEl('circle', { cx: cx, cy: claspY - 4, r: 4, fill: 'none', stroke: '#C9A96E', 'stroke-width': '1.2' }));
        }

        // Head bead + thread loop at top for necklaces
        if (isNecklace && gapAngle > 0) {
            var nFirstAngle = arcStart + (0.5 / displayBeads) * arcRange;
            var nLastAngle = arcStart + ((displayBeads - 0.5) / displayBeads) * arcRange;
            var gapRight = { x: cx + rx * Math.cos(nFirstAngle), y: cy + ry * Math.sin(nFirstAngle) };
            var gapLeft = { x: cx + rx * Math.cos(nLastAngle), y: cy + ry * Math.sin(nLastAngle) };
            var headY = cy - ry - 12;
            var headR = beadR + 1;

            beadsG.appendChild(svgEl('path', {
                d: 'M' + gapLeft.x + ',' + gapLeft.y + ' Q' + (cx - 8) + ',' + (headY + 20) + ' ' + cx + ',' + (headY + headR),
                stroke: '#8B7355', 'stroke-width': '1', fill: 'none'
            }));
            beadsG.appendChild(svgEl('path', {
                d: 'M' + gapRight.x + ',' + gapRight.y + ' Q' + (cx + 8) + ',' + (headY + 20) + ' ' + cx + ',' + (headY + headR),
                stroke: '#8B7355', 'stroke-width': '1', fill: 'none'
            }));

            // Head bead (tower bead)
            var hGrad = svgEl('radialGradient', { id: 'headGrad', cx: '40%', cy: '35%', r: '60%' });
            hGrad.appendChild(svgEl('stop', { offset: '0%', 'stop-color': '#F5EDE0' }));
            hGrad.appendChild(svgEl('stop', { offset: '100%', 'stop-color': '#C9A96E' }));
            beadsG.appendChild(hGrad);
            beadsG.appendChild(svgEl('circle', { cx: cx, cy: headY, r: headR, fill: 'url(#headGrad)', stroke: '#A0794E', 'stroke-width': '0.6' }));

            // Loop above head bead with loose threads fanning out
            var loopTop = headY - headR - 14;
            beadsG.appendChild(svgEl('path', {
                d: 'M' + cx + ',' + (headY - headR) + ' C' + (cx - 10) + ',' + (loopTop + 4) + ' ' + (cx - 12) + ',' + loopTop + ' ' + cx + ',' + (loopTop - 2) + ' C' + (cx + 12) + ',' + loopTop + ' ' + (cx + 10) + ',' + (loopTop + 4) + ' ' + cx + ',' + (headY - headR),
                stroke: '#8B7355', 'stroke-width': '1.2', fill: 'none'
            }));

            // Loose thread ends fanning from the loop
            var fanBase = loopTop - 3;
            [-8, -3, 0, 3, 8].forEach(function(dx) {
                beadsG.appendChild(svgEl('line', {
                    x1: cx + dx * 0.3, y1: fanBase, x2: cx + dx, y2: fanBase - 12 - Math.abs(dx),
                    stroke: '#8B7355', 'stroke-width': '0.8', 'stroke-linecap': 'round'
                }));
            });
        }

        // Beads along arc

        for (var i = 0; i < displayBeads; i++) {
            var angle = arcStart + ((i + 0.5) / displayBeads) * arcRange;
            var bx = cx + rx * Math.cos(angle);
            var by = cy + ry * Math.sin(angle);
            var isSpacer = spacerEvery && spacerEvery > 0 && i > 0 && (spacerEvery === 1 ? (i % 2 === 1) : (i % spacerEvery === 0));

            if (isSpacer && spacerColor) {
                beadsG.appendChild(svgEl('circle', {
                    cx: bx, cy: by, r: beadR - 1.5, fill: spacerColor,
                    stroke: spacerColor === '#C9A96E' ? '#a0794e' : '#666', 'stroke-width': '0.5'
                }));
            } else {
                var gradIndex;
                if (state.arrangement === 'gradient') {
                    var mid = displayBeads / 2;
                    var distFromBottom = Math.abs(i - mid);
                    var t = mid > 0 ? distFromBottom / mid : 0;
                    gradIndex = Math.min(Math.floor(t * grads.length), grads.length - 1);
                } else {
                    gradIndex = i % grads.length;
                }
                var grad = grads[gradIndex];
                var gradId = 'sg' + i;
                var radial = svgEl('radialGradient', { id: gradId, cx: '35%', cy: '35%', r: '65%' });
                [['0%', grad[0]], ['60%', grad[1]], ['100%', grad[2]]].forEach(function(pair) {
                    radial.appendChild(svgEl('stop', { offset: pair[0], 'stop-color': pair[1] }));
                });
                beadsG.appendChild(radial);
                beadsG.appendChild(svgEl('circle', {
                    cx: bx, cy: by, r: beadR, fill: 'url(#' + gradId + ')',
                    stroke: 'rgba(0,0,0,0.08)', 'stroke-width': '0.5'
                }));
            }
        }

        // Guru bead at the bottom
        var guruY = cy + ry + 10;
        if (state.guru && state.guru !== 'none') {
            var guruGradSource = state.guruStone ? getStoneById(state.guruStone) : null;
            var mainGrad = guruGradSource ? guruGradSource.gradient : grads[0];
            var guruObj = GURUS.find(function(g) { return g.id === state.guru; });
            var previewType = guruObj ? guruObj.previewType : 'classic';
            var mColor = SPACER_COLORS[state.spacerMetal] || '#c0c0c0';

            // Threads converging to guru
            var leftBot = { x: cx + rx * Math.cos(Math.PI / 2 - 0.15), y: cy + ry * Math.sin(Math.PI / 2 - 0.15) };
            var rightBot = { x: cx + rx * Math.cos(Math.PI / 2 + 0.15), y: cy + ry * Math.sin(Math.PI / 2 + 0.15) };
            guruG.appendChild(svgEl('line', { x1: leftBot.x, y1: leftBot.y, x2: cx, y2: guruY - 8, stroke: '#8B7355', 'stroke-width': '0.8' }));
            guruG.appendChild(svgEl('line', { x1: rightBot.x, y1: rightBot.y, x2: cx, y2: guruY - 8, stroke: '#8B7355', 'stroke-width': '0.8' }));

            if (previewType === 'sandwich') {
                guruG.appendChild(svgEl('ellipse', { cx: cx, cy: guruY - 6, rx: 7, ry: 4, fill: mColor, stroke: '#999', 'stroke-width': '0.3' }));
                var gsGrad = svgEl('radialGradient', { id: 'guruStone', cx: '35%', cy: '35%', r: '65%' });
                gsGrad.appendChild(svgEl('stop', { offset: '0%', 'stop-color': mainGrad[0] }));
                gsGrad.appendChild(svgEl('stop', { offset: '100%', 'stop-color': mainGrad[2] }));
                guruG.appendChild(gsGrad);
                guruG.appendChild(svgEl('circle', { cx: cx, cy: guruY, r: 7, fill: 'url(#guruStone)' }));
                guruG.appendChild(svgEl('ellipse', { cx: cx, cy: guruY + 6, rx: 7, ry: 4, fill: mColor, stroke: '#999', 'stroke-width': '0.3' }));
            } else {
                var gcGrad = svgEl('radialGradient', { id: 'guruClassic', cx: '35%', cy: '35%', r: '65%' });
                gcGrad.appendChild(svgEl('stop', { offset: '0%', 'stop-color': mainGrad[0] }));
                gcGrad.appendChild(svgEl('stop', { offset: '100%', 'stop-color': mainGrad[2] }));
                guruG.appendChild(gcGrad);
                guruG.appendChild(svgEl('circle', { cx: cx, cy: guruY, r: 9, fill: 'url(#guruClassic)', stroke: 'rgba(0,0,0,0.1)', 'stroke-width': '0.8' }));
            }
        }

        // Finish: tassel / beads / pendant
        var tasselTop = state.guru && state.guru !== 'none' ? guruY + (state.guru === 'sandwich' ? 14 : 12) : cy + ry + 10;
        // Thread from guru to finish
        if (state.finish && state.finishColor) {
            tasselG.appendChild(svgEl('line', { x1: cx, y1: tasselTop - 6, x2: cx, y2: tasselTop + 2, stroke: '#8B7355', 'stroke-width': '0.8' }));

            if (state.finishKind === 'tassel') {
                var tW = 14;
                tasselG.appendChild(svgEl('rect', { x: cx - tW / 2, y: tasselTop, width: tW, height: 4, rx: 2, fill: '#8B7355' }));
                for (var t = -3; t <= 3; t++) {
                    tasselG.appendChild(svgEl('line', {
                        x1: cx + t * 3.5, y1: tasselTop + 4,
                        x2: cx + t * 4.5, y2: tasselTop + 35 + Math.random() * 8,
                        stroke: state.finishColor, 'stroke-width': '2', 'stroke-linecap': 'round'
                    }));
                }
            } else if (state.finishKind === 'beads') {
                var bGrads = grads.length > 0 ? grads : defaultGrad;
                for (var b = 0; b < 5; b++) {
                    var br = 5 - b * 0.5;
                    tasselG.appendChild(svgEl('circle', {
                        cx: cx, cy: tasselTop + b * (br * 2 + 1) + 4, r: br,
                        fill: bGrads[b % bGrads.length][1], stroke: 'rgba(0,0,0,0.08)', 'stroke-width': '0.5'
                    }));
                }
            } else if (state.finishKind === 'pendant') {
                tasselG.appendChild(svgEl('circle', {
                    cx: cx, cy: tasselTop + 14, r: 10, fill: state.finishColor,
                    stroke: 'rgba(0,0,0,0.1)', 'stroke-width': '1'
                }));
                var sym = svgEl('text', {
                    x: cx, y: tasselTop + 18, 'text-anchor': 'middle', fill: 'white',
                    'font-size': '10', 'font-weight': 'bold'
                });
                sym.textContent = state.finish === 'pendant-om' ? 'ॐ' : state.finish === 'pendant-lotus' ? '❁' : '♣';
                tasselG.appendChild(sym);
            }
        }
    }

    // ---- Progress Bar (dynamic) ----
    var CIRCLE_BASE = 'w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center text-sm sm:text-base font-bold transition-all duration-300 ';
    function updateProgressBar() {
        var aSteps = activeSteps();
        var curIdx = aSteps.indexOf(state.currentStep);
        var bar = document.getElementById('progressBar');
        if (bar) {
            bar.innerHTML = '';
            aSteps.forEach(function(key, i) {
                var ind = document.createElement('div');
                ind.className = 'flex flex-col items-center gap-1.5 flex-1 cursor-pointer step-indicator';
                ind.dataset.stepKey = key;

                var circle = document.createElement('div');
                var label = document.createElement('span');
                label.className = 'text-xs sm:text-sm font-medium hidden sm:block ';
                label.textContent = STEP_LABEL[key];

                if (i < curIdx) {
                    circle.className = CIRCLE_BASE + 'bg-terracotta text-white';
                    circle.innerHTML = '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"/></svg>';
                    label.className += 'text-terracotta';
                } else if (i === curIdx) {
                    circle.className = CIRCLE_BASE + 'bg-terracotta text-white ring-4 ring-terracotta/20';
                    circle.textContent = (i + 1);
                    label.className += 'text-terracotta';
                } else {
                    circle.className = CIRCLE_BASE + 'bg-sand text-warm-gray';
                    circle.textContent = (i + 1);
                    label.className += 'text-warm-gray';
                }
                ind.appendChild(circle);
                ind.appendChild(label);
                bar.appendChild(ind);

                if (i < aSteps.length - 1) {
                    var line = document.createElement('div');
                    line.className = 'flex-1 h-0.5 bg-sand rounded -mt-5 sm:-mt-3';
                    var fill = document.createElement('div');
                    fill.className = 'h-full bg-terracotta rounded transition-all duration-500';
                    fill.style.width = (i < curIdx) ? '100%' : '0%';
                    line.appendChild(fill);
                    bar.appendChild(line);
                }
            });
        }

        var dots = document.getElementById('mobileProgressDots');
        if (dots) {
            dots.innerHTML = '';
            aSteps.forEach(function(key, i) {
                var d = document.createElement('div');
                d.className = 'h-1 flex-1 rounded-full ' + (i <= curIdx ? 'bg-terracotta' : 'bg-sand');
                dots.appendChild(d);
            });
        }
    }

    // ---- Step Navigation (key-based, dynamic) ----
    function showStep(key) {
        state.currentStep = key;
        STEP_ORDER_ALL.forEach(function(k) {
            var el = document.getElementById(STEP_DOM[k]);
            if (!el) return;
            if (k === key) { el.classList.remove('inactive','hidden'); el.classList.add('active'); }
            else { el.classList.add('inactive','hidden'); el.classList.remove('active'); }
        });
        var prevBtn = document.getElementById('prevBtn');
        var nextBtn = document.getElementById('nextBtn');
        var addBtn = document.getElementById('addToCartBtn');
        var aSteps = activeSteps();
        var idx = aSteps.indexOf(key);
        if (idx <= 0) { prevBtn.classList.add('hidden'); prevBtn.classList.remove('flex'); }
        else { prevBtn.classList.remove('hidden'); prevBtn.classList.add('flex'); }
        if (isLastStep(key)) { nextBtn.classList.add('hidden'); addBtn.classList.remove('hidden'); addBtn.classList.add('flex'); }
        else { nextBtn.classList.remove('hidden'); nextBtn.classList.add('flex'); addBtn.classList.add('hidden'); }
        if (key === 'stones') renderStonesGrid('all', 'color');
        if (key === 'guru') renderGuruStoneSelector();
        if (key === 'finish' && !state.finish) {
            var bcFinish = FINISHES.find(function(f) { return f.id === 'bead-continuation'; });
            if (bcFinish) selectFinish(bcFinish);
        }
        updateNavState(); updateProgressBar();
        var stepEl = document.getElementById(STEP_DOM[key]);
        if (stepEl) stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateNavState() {
        var nextBtn = document.getElementById('nextBtn');
        var addBtn = document.getElementById('addToCartBtn');
        var sideBtn = document.getElementById('addToCartBtnSide');
        var key = state.currentStep;
        var stepValid = false;
        if (key === 'typeSize') stepValid = !!state.type && !!state.size;
        else if (key === 'closure') stepValid = !!state.closure;
        else if (key === 'stones') stepValid = state.selectedStones.length > 0;
        else if (key === 'spacers') stepValid = !!state.spacerMetal && (state.spacerMetal === 'none' || !!state.spacerCoverage);
        else if (key === 'guru') stepValid = !!state.guru;
        else if (key === 'finish') stepValid = !!state.finish;
        nextBtn.disabled = !stepValid;
        var finishDone = state.closure === 'infinity' ? true : (!!state.guru && !!state.finish);
        var allDone = state.type && state.size && state.closure && state.selectedStones.length > 0 && state.spacerMetal && (state.spacerMetal === 'none' || state.spacerCoverage) && finishDone;
        addBtn.disabled = !allDone;
        sideBtn.disabled = !allDone;
    }

    function selectInGroup(container, selector, el) {
        container.querySelectorAll(selector).forEach(function(b) { b.classList.remove('border-terracotta','shadow-lg','ring-2','ring-terracotta/30'); });
        el.classList.add('border-terracotta','shadow-lg','ring-2','ring-terracotta/30');
    }

    // ---- Update guru preview colors ----
    function updateGuruPreviewColors() {
        var mainGrad = state.selectedStones.length > 0 ? getStoneById(state.selectedStones[0]).gradient : ['#ddd','#bbb','#999'];
        document.querySelectorAll('.guru-classic-preview').forEach(function(el) {
            el.style.background = 'radial-gradient(circle at 35% 35%, ' + mainGrad.join(',') + ')';
        });
        document.querySelectorAll('.guru-sandwich-stone').forEach(function(el) {
            el.style.background = 'radial-gradient(circle at 35% 35%, ' + mainGrad.join(',') + ')';
        });
        var metalColor = state.spacerMetal === 'gold' ? 'linear-gradient(135deg, #ffd700, #C9A96E)' : 'linear-gradient(135deg, #e8e8e8, #c0c0c0)';
        document.querySelectorAll('.guru-sandwich-top').forEach(function(el) { el.style.background = metalColor; });
        document.querySelectorAll('.guru-sandwich-bottom').forEach(function(el) { el.style.background = metalColor; });
    }

    // ---- Step 1: Type Selection ----
    document.querySelectorAll('.type-option').forEach(function(btn) {
        btn.addEventListener('click', function() {
            selectInGroup(document.getElementById('step1'), '.type-option', btn);
            state.type = btn.dataset.type;
            state.size = null; state.beadCount = 0; state.basePrice = 0;
            document.querySelectorAll('.size-option').forEach(function(s) { s.classList.remove('border-terracotta','shadow-lg','ring-2','ring-terracotta/30'); });
            var nSizes = document.getElementById('necklaceSizes');
            var bSizes = document.getElementById('braceletSizes');
            if (state.type === 'necklace') { nSizes.classList.remove('hidden'); bSizes.classList.add('hidden'); }
            else { bSizes.classList.remove('hidden'); nSizes.classList.add('hidden'); }
            updateClosureLabels();
            updateSummary(); updatePreview(); updateNavState();
        });
    });

    // ---- Closure step: adapt labels by type ----
    function updateClosureLabels() {
        var isBracelet = state.type === 'bracelet';
        var noun = isBracelet ? 'צמיד' : 'שרשרת';
        var openAdj = isBracelet ? 'פתוח' : 'פתוחה';
        var beadTitle = document.querySelector('[data-closure-title="bead"]');
        var infTitle = document.querySelector('[data-closure-title="infinity"]');
        if (beadTitle) beadTitle.textContent = noun + ' ' + openAdj + ' עם סגירת חרוז';
        if (infTitle) infTitle.textContent = noun + ' אינפיניטי — ללא חרוז סיום';
    }

    // ---- Closure Selection ----
    document.querySelectorAll('.closure-option').forEach(function(btn) {
        btn.addEventListener('click', function() {
            selectInGroup(document.getElementById('stepClosure'), '.closure-option', btn);
            state.closure = btn.dataset.closure;
            if (state.closure === 'infinity') {
                // Infinity = continuous strand: no guru, no finish.
                state.guru = null; state.guruPrice = 0; state.guruStone = null;
                state.finish = null; state.finishColor = null; state.finishKind = null; state.finishPrice = 0;
                document.querySelectorAll('.guru-option, .finish-option').forEach(function(b) {
                    b.classList.remove('border-terracotta','shadow-lg','ring-2','ring-terracotta/30');
                });
            }
            updateSummary(); updatePreview(); updateNavState(); updateProgressBar();
        });
    });

    // ---- Step 5: Finish Toggles ----
    var toggleTassel = document.getElementById('toggleTassel');
    var toggleBeadCont = document.getElementById('toggleBeadCont');
    var togglePendant = document.getElementById('togglePendant');
    var tasselOpts = document.getElementById('tasselOptions');
    var beadContOpts = document.getElementById('beadContOptions');
    var pendantOpts = document.getElementById('pendantOptions');

    function clearFinishSelection() {
        state.finish = null; state.finishColor = null; state.finishKind = null; state.finishPrice = 0;
        document.querySelectorAll('.finish-option').forEach(function(b) { b.classList.remove('border-terracotta','shadow-lg','ring-2','ring-terracotta/30'); });
        updateSummary(); updatePreview(); updateNavState();
    }

    function setActiveToggle(active) {
        [toggleTassel, toggleBeadCont, togglePendant].forEach(function(t) {
            if (!t) return;
            t.classList.remove('bg-white','text-brown-dark','shadow-sm');
            t.classList.add('text-warm-gray');
        });
        if (active) {
            active.classList.add('bg-white','text-brown-dark','shadow-sm');
            active.classList.remove('text-warm-gray');
        }
    }

    if (toggleTassel) toggleTassel.addEventListener('click', function() {
        setActiveToggle(toggleTassel);
        if (tasselOpts) tasselOpts.classList.remove('hidden');
        if (beadContOpts) beadContOpts.classList.add('hidden');
        if (pendantOpts) pendantOpts.classList.add('hidden');
        clearFinishSelection();
    });
    if (toggleBeadCont) toggleBeadCont.addEventListener('click', function() {
        setActiveToggle(toggleBeadCont);
        if (beadContOpts) beadContOpts.classList.remove('hidden');
        if (tasselOpts) tasselOpts.classList.add('hidden');
        if (pendantOpts) pendantOpts.classList.add('hidden');
        clearFinishSelection();
    });
    if (togglePendant) togglePendant.addEventListener('click', function() {
        setActiveToggle(togglePendant);
        if (pendantOpts) pendantOpts.classList.remove('hidden');
        if (tasselOpts) tasselOpts.classList.add('hidden');
        if (beadContOpts) beadContOpts.classList.add('hidden');
        clearFinishSelection();
    });

    // ---- Navigation ----
    document.getElementById('nextBtn').addEventListener('click', function() {
        var aSteps = activeSteps();
        var idx = aSteps.indexOf(state.currentStep);
        if (idx > -1 && idx < aSteps.length - 1) {
            if (state.currentStep === 'stones') updateGuruPreviewColors();
            showStep(aSteps[idx + 1]);
        }
    });
    document.getElementById('prevBtn').addEventListener('click', function() {
        var aSteps = activeSteps();
        var idx = aSteps.indexOf(state.currentStep);
        if (idx > 0) showStep(aSteps[idx - 1]);
    });

    // Step indicators are rebuilt dynamically, so use delegation on the bar.
    var progressBarEl = document.getElementById('progressBar');
    if (progressBarEl) {
        progressBarEl.addEventListener('click', function(e) {
            var ind = e.target.closest('.step-indicator');
            if (!ind) return;
            var key = ind.dataset.stepKey;
            var aSteps = activeSteps();
            if (aSteps.indexOf(key) > -1 && aSteps.indexOf(key) < aSteps.indexOf(state.currentStep)) {
                showStep(key);
            }
        });
    }

    // ---- Add to Cart ----
    function resetCartButtons(btns) {
        btns.forEach(function(b) {
            if (!b) return;
            b.disabled = false;
            b.innerHTML = b.id === 'addToCartBtn'
                ? '<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg> הוסיפו לעגלה'
                : 'הוסיפו לעגלה';
            b.classList.remove('bg-sage'); b.classList.add('bg-terracotta','hover:bg-terracotta-dark');
        });
    }

    function findClosestSurchargeVariant(surchargeVariants, amount) {
        if (!amount || amount <= 0) return null;
        var bestKey = null, bestDiff = Infinity;
        for (var key in surchargeVariants) {
            if (key === '_none') continue;
            var price = parseInt(key);
            if (isNaN(price) || price <= 0) continue;
            var diff = Math.abs(price - amount);
            if (diff < bestDiff || (diff === bestDiff && price >= amount)) {
                bestDiff = diff;
                bestKey = key;
            }
        }
        return bestKey;
    }

    function addCustomMalaToCart() {
        var variantData = document.getElementById('builderVariants');
        if (!variantData) { alert('שגיאה: מוצר עיצוב אישי לא הוגדר. פנו למנהל החנות.'); return; }
        var variants;
        try { variants = JSON.parse(variantData.textContent); } catch(e) { alert('שגיאה בטעינת נתוני המוצר.'); return; }

        var typePrefix = state.type === 'necklace' ? 'n' : 'b';
        var variantKey = (typePrefix + state.size).toLowerCase();
        var variantId = variants[variantKey];
        if (!variantId) { alert('לא נמצאה גרסת מוצר מתאימה. פנו למנהל החנות.'); return; }

        var stoneNames = state.selectedStones.map(function(id) { var s = getStoneById(id); return s ? s.name : id; }).join(', ');
        var spacerObj = SPACERS.find(function(s) { return s.metal === state.spacerMetal; });
        var spacerDesc = state.spacerCoverage === 'designer' ? 'סומכים על המעצב' : (state.spacerMetal === 'none' ? 'ללא' : ((spacerObj ? spacerObj.metalName : state.spacerMetal) + (state.spacerCoverage ? ' - ' + (COVERAGE_MAP[state.spacerCoverage] || state.spacerCoverage) : '')));
        var guruDesc = state.guru ? (GURU_MAP[state.guru] || state.guru) : 'ללא';
        var finishDesc = state.finish ? (FINISH_MAP[state.finish] || state.finish) : 'ללא';
        var totalPrice = getPrice();
        var surchargeAmount = totalPrice - state.basePrice;

        var arrangementMap = { sequential: 'לסירוגין', gradient: 'גרדיאנט', designer: 'סומכים על המעצב' };
        var guruStoneDesc = '';
        if (state.guruStone) {
            var gs = getStoneById(state.guruStone);
            guruStoneDesc = gs ? ' (' + gs.name + ')' : '';
        } else {
            guruStoneDesc = ' (זהה לשרשרת)';
        }

        var properties = {
            'סוג': state.type === 'necklace' ? 'שרשרת' : 'צמיד',
            'גודל': state.beadCount + ' חרוזים' + (state.type === 'bracelet' ? ' (' + state.size + ')' : ''),
            'סגירה': state.closure === 'infinity' ? 'אינפיניטי (ללא חרוז סיום)' : 'פתוחה עם סגירת חרוז',
            'אבנים': stoneNames,
            'סידור חרוזים': arrangementMap[state.arrangement] || 'לסירוגין',
            'חוצצים': spacerDesc,
            'גורו': guruDesc + guruStoneDesc,
            'סיום': finishDesc,
            'סה״כ כולל תוספות': '₪' + totalPrice
        };

        if (state.closure === 'infinity') {
            delete properties['גורו'];
            delete properties['סיום'];
        }

        var btns = [document.getElementById('addToCartBtn'), document.getElementById('addToCartBtnSide')];
        btns.forEach(function(b) { if (b) { b.disabled = true; b.textContent = 'מוסיף...'; } });

        var items = [{ id: variantId, quantity: 1, properties: properties }];

        if (surchargeAmount > 0) {
            var surchargeData = document.getElementById('surchargeVariants');
            var surchargeVariants = null;
            try { if (surchargeData) surchargeVariants = JSON.parse(surchargeData.textContent); } catch(e) {}

            if (surchargeVariants) {
                var surchargeKey = findClosestSurchargeVariant(surchargeVariants, surchargeAmount);
                if (surchargeKey && surchargeVariants[surchargeKey]) {
                    var surchargeDetails = [];
                    state.selectedStones.forEach(function(id) {
                        var s = getStoneById(id);
                        if (s && s.priceAdd > 0) surchargeDetails.push(s.name + ' +₪' + s.priceAdd);
                    });
                    if (state.spacerPrice > 0) surchargeDetails.push('חוצצים +₪' + state.spacerPrice);
                    if (state.guruPrice > 0) surchargeDetails.push('גורו +₪' + state.guruPrice);
                    if (state.finishPrice > 0) surchargeDetails.push('סיום +₪' + state.finishPrice);
                    items.push({
                        id: surchargeVariants[surchargeKey],
                        quantity: 1,
                        properties: { 'פירוט': surchargeDetails.join(', '), '_builder_addon': 'true' }
                    });
                }
            }
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
            btns.forEach(function(b) {
                if (!b) return;
                b.textContent = '✓ נוסף לעגלה!';
                b.classList.add('bg-sage'); b.classList.remove('bg-terracotta','hover:bg-terracotta-dark');
            });
            if (typeof window.refreshCartDrawer === 'function') {
                window.refreshCartDrawer().then(function() {
                    var cartPanel = document.getElementById('cartPanel');
                    var cartOverlay = document.getElementById('cartOverlay');
                    if (cartPanel) { cartPanel.classList.remove('-translate-x-full'); }
                    if (cartOverlay) { cartOverlay.classList.remove('opacity-0', 'pointer-events-none'); }
                    document.body.style.overflow = 'hidden';
                });
            } else if (typeof updateCartCount === 'function') {
                updateCartCount();
                var cartBtn = document.getElementById('cartBtn');
                if (cartBtn) cartBtn.click();
            }
            setTimeout(function() { resetCartButtons(btns); }, 3000);
        })
        .catch(function(err) {
            btns.forEach(function(b) { if (b) { b.disabled = false; b.textContent = 'שגיאה - נסו שוב'; } });
            setTimeout(function() { resetCartButtons(btns); }, 2000);
        });
    }

    [document.getElementById('addToCartBtn'), document.getElementById('addToCartBtnSide')].forEach(function(btn) {
        if (btn) btn.addEventListener('click', function() { if (!btn.disabled) addCustomMalaToCart(); });
    });

    // ---- Filter Chip Styling ----
    var style = document.createElement('style');
    style.textContent = '.filter-chip { border-color: #E8DDD3; background: white; color: #6B6560; } .filter-chip:hover { border-color: #A0522D; color: #A0522D; } .filter-chip.active { border-color: #A0522D; background: #A0522D; color: white; }';
    document.head.appendChild(style);

    // Spacer designer button
    var spacerDesignerBtn = document.getElementById('spacerDesignerBtn');
    if (spacerDesignerBtn) {
        spacerDesignerBtn.addEventListener('click', function() {
            selectInGroup(document.getElementById('step3'), '.spacer-metal-option', spacerDesignerBtn);
            state.spacerMetal = 'none';
            state.spacerCoverage = 'designer';
            state.spacerPrice = 0;
            document.getElementById('spacerCoverage').classList.add('hidden');
            updateSummary(); updatePreview(); updateNavState();
        });
    }

    // ---- Mobile Preview Drawer Toggle ----
    var mobilePreviewToggle = document.getElementById('mobilePreviewToggle');
    var mobilePreviewDrawer = document.getElementById('mobilePreviewDrawer');
    var previewChevron = document.getElementById('previewChevron');
    if (mobilePreviewToggle && mobilePreviewDrawer) {
        mobilePreviewToggle.addEventListener('click', function() {
            mobilePreviewDrawer.classList.toggle('open');
            if (previewChevron) {
                previewChevron.style.transform = mobilePreviewDrawer.classList.contains('open') ? 'rotate(180deg)' : '';
            }
            if (mobilePreviewDrawer.classList.contains('open')) syncMobileFullPreview();
        });
    }

    function syncMobileFullPreview() {
        var src = document.getElementById('previewBeads');
        var srcGuru = document.getElementById('previewGuru');
        var srcTassel = document.getElementById('previewTassel');
        var dst = document.getElementById('mobilePreviewBeadsFull');
        var dstGuru = document.getElementById('mobilePreviewGuruFull');
        var dstTassel = document.getElementById('mobilePreviewTasselFull');
        if (src && dst) dst.innerHTML = src.innerHTML;
        if (srcGuru && dstGuru) dstGuru.innerHTML = srcGuru.innerHTML;
        if (srcTassel && dstTassel) dstTassel.innerHTML = srcTassel.innerHTML;

        var fields = [
            ['summaryType', 'mobileSummaryType'],
            ['summarySize', 'mobileSummarySize'],
            ['summaryStones', 'mobileSummaryStones'],
            ['summarySpacer', 'mobileSummarySpacer'],
            ['summaryGuru', 'mobileSummaryGuru'],
            ['summaryFinish', 'mobileSummaryFinish'],
            ['summaryPrice', 'mobileSummaryPriceFull']
        ];
        fields.forEach(function(pair) {
            var s = document.getElementById(pair[0]);
            var d = document.getElementById(pair[1]);
            if (s && d) d.textContent = s.textContent;
        });
    }

    // Patch updatePreview to also sync mobile
    var _origUpdatePreview = updatePreview;
    updatePreview = function() {
        _origUpdatePreview();
        if (mobilePreviewDrawer && mobilePreviewDrawer.classList.contains('open')) {
            syncMobileFullPreview();
        }
    };

    // ---- Init ----
    renderStep1();
    renderStep3();
    renderStep4();
    renderStep5();
    setupFilters();
    renderStonesGrid('all', 'color');
    updatePreview(); updateSummary(); updateProgressBar();
})();
